<template>
  <div class="try-it-out-component">
    <div class="columns">
      <div class="column is-7 -height-adjust">
        <SectionTitle
          title="Try It Out"
          subtitle="Our developer service is still in beta, but you can try our mobile app today. CrowdFlik is built on the same
          tech that we're releasing, so it's a great way to get a sneak peek at
          our API's capabilities."
          class="has-margin-bottom-20"
        />

        <div class="has-text-centered-mobile">
          <a
            href="https://itunes.apple.com/us/app/crowdflik-crowd-powered-video/id659091959?mt=8"
            class="has-margin-right-5"
          >
            <img src="@/assets/img/badges/01.svg" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.crowdflik.crowdflikapp&amp;hl=en_US"
            ><img src="@/assets/img/badges/02.svg" class="has-margin-left-5"
          /></a>
        </div>
      </div>
      <div class="column -image-preview-adjust">
        <img src="@/assets/img/previews/01.png" />
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from "@/components/SectionTitle.vue";

export default {
  name: "TryItOutComponent",
  components: {
    SectionTitle
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.-image-preview-adjust {
  margin-top: -100px;
}

.-height-adjust {
  margin-top: 40px;
  margin-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  .-height-adjust {
    margin-top: 10px;
  }
}
</style>
